const JohnBehrProfile = () => (
  <article className="john-behr-profile" aria-labelledby="john-behr-title">
    <div className="john-behr-profile__inner">
      <figure className="john-behr-profile__portrait">
        <img src="/john-behr.jpg" alt="John Behr, PhD" width="503" height="724" decoding="async" />
      </figure>

      <div className="john-behr-profile__content">
        <p className="john-behr-profile__eyebrow">About John Behr</p>
        <h1 id="john-behr-title">John Behr, PhD</h1>
        <p className="john-behr-profile__role">Industrial-Organizational Psychologist</p>
        <div className="john-behr-profile__rule" aria-hidden="true" />

        <div className="john-behr-profile__biography">
          <p>
            John Behr, PhD, is an industrial-organizational psychologist whose work has included
            executive assessment, leadership development and succession.
          </p>
          <p>
            His professional experience spans senior leadership contexts including energy,
            healthcare, pharmaceuticals and government.
          </p>
        </div>

        <dl className="john-behr-profile__details" aria-label="Professional background">
          <div>
            <dt>Professional focus</dt>
            <dd>Executive assessment · Leadership development · Succession</dd>
          </div>
          <div>
            <dt>Leadership contexts</dt>
            <dd>Energy · Healthcare · Pharmaceuticals · Government</dd>
          </div>
        </dl>

        <nav className="john-behr-profile__links" aria-label="John Behr professional profiles">
          <a href="https://www.linkedin.com/in/johnbehr" target="_blank" rel="noopener noreferrer">
            LinkedIn <span aria-hidden="true">↗</span>
          </a>
          <a href="https://leaderbridge.com/about" target="_blank" rel="noopener noreferrer">
            LeaderBridge profile <span aria-hidden="true">↗</span>
          </a>
        </nav>
      </div>
    </div>
  </article>
)

export default JohnBehrProfile
